import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  const halfLen = Math.ceil(categories.length / 2);
  const col1 = categories.slice(0, halfLen);
  const col2 = categories.slice(halfLen);

  return (
    <footer className="w-full bg-background-900 text-foreground-200">
      <div className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-8">

          <div className="lg:col-span-2">
            <span className="font-heading text-xl md:text-2xl font-bold text-white tracking-tight">
              Kakobuy
            </span>
            <p className="text-sm text-foreground-400 mt-4 max-w-md leading-relaxed">
              {t('footer_description')}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">{t('footer_links_categories')}</h4>
            <ul className="space-y-2.5">
              {col1.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer"
                  >
                    {cat.namePl}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">&nbsp;</h4>
            <ul className="space-y-2.5">
              {col2.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer"
                  >
                    {cat.namePl}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">{t('nav_guides')}</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/artykul/najlepszy-kakobuy-spreadsheet-2026" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">
                  {t('section_article_heading')}
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">
                  {t('btn_spreadsheet')}
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">
                  {t('btn_buy_now')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-700/30 mt-12 pt-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-6">
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">
                <span className="w-4 h-4 inline-flex items-center justify-center mr-1">
                  <i className="ri-external-link-line text-xs"></i>
                </span>
                kaspreadsheet.com
              </a>
              <Link to="/" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">
                {t('breadcrumb_home')}
              </Link>
            </div>
            <p className="text-xs text-foreground-500">
              {t('footer_copyright')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}